// extracted by mini-css-extract-plugin
export default {"background":"AuthBackground_background__4GJFh","svg-background":"AuthBackground_svg-background__jvw-U","ball1":"AuthBackground_ball1__kKB2p","ball2":"AuthBackground_ball2__c5JZ2"};